module.exports = __webpack_public_path__ + "img/profile-pic.d4203ab2.svg";